import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import ListingCard from '../components/ListingCard';
import './Home.css';

const CATEGORIES = [
  { value: 'street_legal', letter: 'SL', name: 'Street Legal' },
  { value: 'mini_moto',    letter: 'MM', name: 'Mini Moto'    },
  { value: 'medium_moto',  letter: 'MD', name: 'Medium Moto'  },
  { value: 'mega_moto',    letter: 'MG', name: 'Mega Moto'    },
  { value: 'part',         letter: 'PT', name: 'Parts'        },
  { value: 'accessory',    letter: 'AC', name: 'Accessories'  },
];

export default function Home() {
  const [recent, setRecent] = useState([]);
  const [stats, setStats] = useState({ total: 0, bikes: 0, parts: 0 });
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    const { data } = await supabase
      .from('listings').select('*').eq('is_active', true)
      .order('created_at', { ascending: false }).limit(6);
    if (data) setRecent(data);

    const { count: total } = await supabase.from('listings').select('*', { count: 'exact', head: true }).eq('is_active', true);
    const { count: bikes } = await supabase.from('listings').select('*', { count: 'exact', head: true }).eq('is_active', true).in('category', ['street_legal','mini_moto','medium_moto','mega_moto']);
    const { count: parts } = await supabase.from('listings').select('*', { count: 'exact', head: true }).eq('is_active', true).in('category', ['part','accessory']);
    setStats({ total: total || 0, bikes: bikes || 0, parts: parts || 0 });
  }

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/listings?q=${encodeURIComponent(search)}`);
  };

  return (
    <div className="home page-enter">
      {/* Hero */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-orb" />
          <div className="hero-orb-2" />
          <div className="hero-line" />
        </div>
        <div className="container hero-content">
          <div className="hero-eyebrow">Electric Moto Marketplace</div>
          <h1 className="hero-title">
            BUY & SELL<br />
            <span className="hero-title-sub glow-text">E-MOTOS</span>
          </h1>
          <p className="hero-body">
            The dedicated marketplace for electric motorcycle enthusiasts.
            Find bikes, parts, and accessories from real sellers across the country.
          </p>

          <form className="hero-search" onSubmit={handleSearch}>
            <input
              type="text"
              className="form-input"
              placeholder="Search brand, model, city..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <button type="submit" className="btn btn-primary">Search</button>
          </form>

          <div className="hero-stats">
            <div>
              <span className="stat-num">{stats.total}</span>
              <span className="stat-label">Listings</span>
            </div>
            <div className="stat-sep" />
            <div>
              <span className="stat-num">{stats.bikes}</span>
              <span className="stat-label">Bikes</span>
            </div>
            <div className="stat-sep" />
            <div>
              <span className="stat-num">{stats.parts}</span>
              <span className="stat-label">Parts & Gear</span>
            </div>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="categories container">
        <p className="section-label">Browse by type</p>
        <div className="categories-grid">
          {CATEGORIES.map(c => (
            <Link key={c.value} to={`/listings?category=${c.value}`} className="cat-card">
              <span className="cat-letter">{c.letter}</span>
              <span className="cat-name">{c.name}</span>
            </Link>
          ))}
        </div>
      </section>

      {/* Recent */}
      <section className="recent container">
        <div className="section-header">
          <div>
            <h2 className="section-title">Recent Listings</h2>
            <p className="section-sub">Freshest arrivals on the marketplace</p>
          </div>
          <Link to="/listings" className="btn btn-outline btn-sm">View All</Link>
        </div>

        {recent.length > 0 ? (
          <div className="listings-grid">
            {recent.map(l => <ListingCard key={l.id} listing={l} />)}
          </div>
        ) : (
          <div className="empty-state">
            <h3>No listings yet</h3>
            <p>Be the first to list your e-moto.</p>
            <Link to="/sell" className="btn btn-primary" style={{ marginTop: 20 }}>List Your Bike</Link>
          </div>
        )}
      </section>

      {/* CTA */}
      <section className="cta-section container">
        <div className="cta-inner">
          <div>
            <h2>Ready to sell?</h2>
            <p>List in minutes. Reach buyers who are actively looking.</p>
          </div>
          <Link to="/sell" className="btn btn-primary btn-lg">Start Listing Free</Link>
        </div>
      </section>
    </div>
  );
}
